export type SettingsScope = "platform" | "agent" | "capabilities" | "scenes";

export function settingsScope(hash: string): SettingsScope {
  const params = new URLSearchParams(hash.split("?")[1]);
  const scope = params.get("scope");
  return scope === "platform" || params.get("section") === "workspace" ? "platform"
    : scope === "capabilities" || scope === "scenes" ? scope : "agent";
}

export function SettingsTabs({ value, onChange }: { value: SettingsScope; onChange: (scope: SettingsScope) => void }) {
  return <nav className="pa-tabs-list connections-scope" aria-label="设置范围">
    {([["platform", "平台"], ["agent", "Agent 设置"], ["capabilities", "能力"], ["scenes", "场景"]] as const).map(([scope, label]) =>
      <button type="button" className="pa-tab" key={scope} aria-current={value === scope ? "page" : undefined} onClick={() => onChange(scope)}>{label}</button>)}
  </nav>;
}
